"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var SearchSmall = function SearchSmall(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#fff" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7064412,14.2892675 L13.1016978,11.6837415 C13.0877045,11.6697494 13.0717122,11.659755 13.0567195,11.6467624 C14.4483168,9.5323824 14.0141646,6.70801695 12.0517738,5.10911515 C10.0893829,3.51021335 7.23530352,3.65541862 5.44534672,5.44522634 C3.65538991,7.23503406 3.51017255,10.0888757 5.10920753,12.0511032 C6.70824251,14.0133306 9.53284321,14.4474466 11.6473993,13.0559652 C11.6603931,13.0709567 11.6703882,13.0869476 11.683382,13.1009397 L14.289125,15.7064657 C14.5423041,15.9596238 14.9113208,16.0584934 15.25717,15.9658311 C15.6030193,15.8731688 15.8731583,15.6030523 15.9658283,15.2572319 C16.0584983,14.9114115 15.9596205,14.5424255 15.7064412,14.2892675 L15.7064412,14.2892675 Z M8.93670695,12.1584729 C7.63375368,12.1584729 6.45909757,11.3736582 5.96047894,10.1699866 C5.46186031,8.96631495 5.73747355,7.58082901 6.65880065,6.65957864 C7.58012775,5.73832828 8.96572909,5.46273799 10.169501,5.96131509 C11.3732728,6.4598922 12.1581529,7.63445047 12.1581529,8.93729523 C12.1581529,10.7163025 10.7158624,12.1584729 8.93670695,12.1584729 L8.93670695,12.1584729 Z",
    id: "searchSmall"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#searchSmall"
  }));
};

var _default = SearchSmall;
exports["default"] = _default;
module.exports = exports["default"];